<template>
    <div class="hg-media-controls" :data-mode="mode">
        <div class="mc-box-left">
            <button  @click="play()" class="btn-transparent btn-round" v-if="mode != 'draw' && !playing" :title="'PLAY' | i18n">
                <font-awesome-icon :icon="['fas','play']"/>
            </button>
            <button  @click="$emit('pause')" class="btn-transparent btn-round" v-if="mode != 'draw' && mode != 'marker' && playing" :title="'PAUSE' | i18n">
                <font-awesome-icon :icon="['fas','pause']"/>
            </button>
            <button  @click="play(true)" class="btn-transparent btn-round" v-if="enableAutozoom && $hisport.permissions.isAdmin()  && mode != 'draw' && !playing && !!autozoom && Array.isArray(autozoom.results) && autozoom.results.length>0" :title="'PLAY_WITH_AUTOZOOM' | i18n">
                <font-awesome-icon :icon="['fas','robot']"/>
            </button>
            <button  @click="requestAutozoom()" class="btn-transparent btn-round" v-if="enableAutozoom && $hisport.permissions.isAdmin()  && mode != 'draw' && !!autozoom && autozoom.errored" :title="'REQUEST_AUTOZOOM' | i18n">
                <font-awesome-icon :icon="['fas','magic']"/>
            </button>
            <button     @click="stopRecordMarkers()"   
                        class="btn-transparent btn-round" 
                        v-if="mode == 'marker' && playing"
                        :title="'STOP_RECORD_MARKERS' |i18n">
                <font-awesome-icon :icon="['fas','stop']"/>
            </button> 

            <div class="mc-time" v-if="mode != 'draw'" :title="'CURRENT_TIME' | i18n">
                <span class="mc-time-current">{{currentTime | sec2time(true)}}</span> 
                <span class="mc-time-divider">/</span> 
                <span class="mc-time-total">{{duration | sec2time(true)}}</span>
            </div>



            <div class="draw-panel panel-color" v-show="drawColorPanel" :title="'DRAW_COLOR' | i18n">
                <!-- <h4 v-i18n="'CHOOSE_COLOR'"></h4> -->
                <ul><li v-for="c in colors" :key="c">
                <a href="javascript: void 0" @click="$emit('drawColor', c); drawColor = c; drawColorPanel = false">
                <span class="color" :style="{backgroundColor:c}" :title="c"></span>
                </a></li></ul>        
            </div>
            <div class="draw-panel panel-size" v-show="drawSizePanel" :title="'DRAW_SIZE' |i18n">
                <!-- <h4 v-i18n="'CHOOSE_BRUSH_SIZE'"></h4> -->
                <ul><li v-for="s in sizes" :key="s">
                <a href="javascript: void 0" @click="$emit('drawSize', s); drawBrushSize = s; drawColorPanel = false">
                <span class="size" :style="{width:s + 'px', height: s+'px'}" :title="s"></span>
                </a></li></ul>        
            </div>
            <div class="draw-panel panel-shapemode" v-show="drawShapePanel" :title="'DRAW_SHAPE' | i18n">
                <!-- <h4 v-i18n="'CHOOSE_DRAW_MODE'"></h4> -->
                <ul><li v-for="m in modes" :key="m">
                <a href="javascript: void 0" @click="$emit('drawMode', m); drawShapeMode = m; drawColorPanel = false">
                <span class="mode">
                    <font-awesome-icon :icon="['fas','paint-brush']" v-if="m=='draw'"/>
                    <font-awesome-icon :icon="['fas','square']" v-if="m=='rectangle'"/>
                    <font-awesome-icon :icon="['fas','circle']" v-if="m=='circle'"/>
                </span>
                </a></li></ul>       
            </div>

            <button     @click="drawColorPanel = !drawColorPanel; drawSizePanel = false; drawShapePanel = false;" 
                        class="btn-color btn-transparent btn-round"  
                        :title="'CHANGE_COLOR' |i18n"
                        :style="{background:drawColor}"
                        v-if="mode=='draw'">
            </button>
            <button     @click="drawSizePanel = !drawSizePanel;drawColorPanel = false; drawShapePanel = false;" 
                        class="btn-transparent btn-round"  
                        :title="'CHANGE_BRUSH_SIZE' | i18n"
                        v-if="mode=='draw'">
                <span class="size" :style="{width:drawBrushSize + 'px', height: drawBrushSize+'px'}" :title="drawBrushSize"></span>
            </button>
            <button     @click="drawShapePanel = !drawShapePanel;drawSizePanel = false;drawColorPanel = false;" 
                        class="btn-transparent btn-round"  
                        :title="'CHANGE_SHAPE' | i18n"
                        v-if="mode=='draw'">
                <font-awesome-icon :icon="['fas','paint-brush']" v-if="drawShapeMode=='draw'"/>
                <font-awesome-icon :icon="['fas','square']" v-if="drawShapeMode=='rectangle'"/>
                <font-awesome-icon :icon="['fas','circle']" v-if="drawShapeMode=='circle'"/>
            </button>
        </div>



        <div class="mc-box-center">
            <button     @click="showTagList = !showTagList; $emit('toggleTagList', showTagList)" 
                        class="btn-round"
                        v-if="['marker','draw'].indexOf(mode)<0 && enableTagClip"
                        :class="{'btn-red':!showTagList, 'btn-info':showTagList }"  
                        :title="$hisport.options.platform.CONFIGURATION.AUTO_GENERATE_CLIPS_BY_TAG?($options.filters.i18n(showTagList?'HIDE_CLIP_LIST':'SHOW_CLIP_LIST')):($options.filters.i18n(showTagList?'HIDE_TAG_LIST':'SHOW_TAG_LIST'))">
                <font-awesome-icon :icon="['fas','list']"/>
            </button>

            <button     @click="recordMarkers()"   
                        class="btn-red btn-round" 
                        :title="'RECORD_MARKERS' | i18n"
                        v-if="mode == 'marker' && !playing">
                <!-- <font-awesome-icon :icon="['fas','play']"/> -->
                <!-- <div style="background:red;border-radius:50%;width:5px;height:5px;position:relative;filter:scale(0.1);right:-5px;bottom:12px;"/> -->
            </button> 
            <!-- <button     @click="$emit('addMarker')"   
                        class="btn-red btn-round" 
                        :disabled="!enablePZR || (enablePreview && playing)"
                        v-else-if="mode == 'marker'">
                <font-awesome-icon :icon="['fas','map-pin']"/>
            </button> -->
            <div v-if="mode == 'draw'" style="display:flex">
                <button @click.prevent="$emit('drawUndo')" class="btn-transparent btn-round" :title="'UNDO' |i18n">
                    <font-awesome-icon :icon="['fas','undo-alt']"/>
                </button>
                <button @click.prevent="$emit('drawSave')" class="btn-transparent btn-round" :title="'SAVE' |i18n">
                    <font-awesome-icon :icon="['fas','save']"/>
                </button>
                <button @click.prevent="$emit('drawRedo')" class="btn-transparent btn-round" :title="'REDO' |i18n">
                    <font-awesome-icon :icon="['fas','redo-alt']"/>
                </button>
            </div>    
        </div>


        <div class="mc-box-right">
            <help/>
            
            <a  class="btn-transparent btn-round resolution-switcher" 
                :title="'CHANGE_RESOLUTION' | i18n"
                v-if="availableResolutions.length>1" @click="showResolution = !showResolution">
                <strong>
                    <span v-if="selectedResolution == 'xhd'">UHD (4K/8K)</span>
                    <span v-else-if="selectedResolution == 'mhd'">HD (1440p)</span>
                    <span v-else-if="selectedResolution == 'hd'">HD (1080p)</span>
                    <span v-else-if="selectedResolution == 'md'">HD (720p)</span>
                    <span v-else-if="selectedResolution == 'sd'">SD (540p)</span>
                    <span v-else-if="selectedResolution == 'ld'">SD (360p)</span>
                    <span v-else>{{selectedResolution}}</span>
                </strong>
                <ul v-if="showResolution" >
                    <li v-for="id in ['xhd','mhd','hd','md','sd','ld'].filter(x=>availableResolutions.indexOf(x)>=0)" 
                        :key="id"
                        :class="{selected: id == selectedResolution}"
                        @click.prevent="$emit('changeResolution', id);">
                        <span v-if="id      == 'xhd'">UHD (4K/8K)</span>
                        <span v-else-if="id == 'mhd'">HD (1440p)</span>
                        <span v-else-if="id == 'hd'">HD (1080p)</span>
                        <span v-else-if="id == 'md'">HD (720p)</span>
                        <span v-else-if="id == 'sd'">SD (540p)</span>
                        <span v-else-if="id == 'ld'">SD (360p)</span>
                    </li>
                </ul>
            </a>

            <!-- <button @click.prevent="$emit('togglePZR')" v-if="!mode || mode=='tag'" :hg-active="String(enablePZR)" class="btn-transparent btn-round" >
                <font-awesome-icon :icon="['fas','search-minus']" v-if="enablePZR"/>
                <font-awesome-icon :icon="['fas','search-plus']" v-else/>
            </button> -->
            <button @click.prevent="$emit('zoomOut')" 
                    :title="'ZOOM_OUT' | i18n"
                    v-if="!mode || mode!='marker'" :hg-active="String(actualZoom > 1)" class="btn-transparent btn-round" >
                <font-awesome-icon :icon="['fas','search-minus']"/>
            </button> 
            <button @click.prevent="$emit('zoomIn')" 
                    :title="'ZOOM_IN' | i18n"
                    v-if="!mode || mode!='marker'" :hg-active="String(actualZoom < 15)" class="btn-transparent btn-round" >
                <font-awesome-icon :icon="['fas','search-plus']"/>
            </button> 
            <button @click.prevent="$emit('toggleDraw')" 
                    :title="'DRAW' | i18n"
                    v-if="!!enablePZR && ['tag','draw'].indexOf(mode)>=0" :hg-active="String(enableDraw)" class="btn-transparent btn-round" >
                <font-awesome-icon :icon="['fas','palette']"/>
            </button>
            <button @click.prevent="$emit('download')" 
                    :title="'DOWNLOAD' | i18n"
                    :hg-active="true" class="btn-transparent btn-round" >
                <font-awesome-icon :icon="['fas','download']"/>
            </button>
            <button @click.prevent="$emit('showInfo')" 
                    :title="'SHOW_INFO' | i18n" :hg-active="true" class="btn-transparent btn-round" v-if="$hisport.permissions.isAdmin()">
                <font-awesome-icon :icon="['fas','info-circle']"/>
            </button>
            <button @click.prevent="$emit('edit')" 
                    :title="'EDIT_EVENT' | i18n"
                    :hg-active="true" class="btn-transparent btn-round" v-if="enableEdit">
                <font-awesome-icon :icon="['fas','edit']"/>
            </button>
            <!-- <button @click.prevent="$emit('togglePreview')" :disabled="!enablePZR || mode!='marker'" :hg-active="String(enablePreview)" class="btn-transparent btn-round" >
                <font-awesome-icon :icon="['fas','route']"/>
            </button> -->
            <!-- 
                <img src="../../assets/images/maximize.svg"/>
                <img src="../../assets/images/audio.svg" v-if="muted"  @click="mute()"/>
                <img src="../../assets/images/audio.svg" v-if="!muted"  @click="unmute()"/>
            -->
        </div> 
    </div>
</template>
<style scoped>
.resolution-switcher{
    background: rgba(255,255,255,.1);
    font-size:10px;
    text-align:center;
    text-transform: uppercase;
    border-radius:5px;
    width:80px;
    cursor: pointer;
    position: relative;
}
.resolution-switcher:hover{
    background: rgba(255,255,255,.3);
}
.resolution-switcher strong span{
    color: #FFFFFF;
}
.resolution-switcher ul{
    margin:0;
    padding:0;
    list-style-type:none;
    background:#ffffff;
    position:absolute;
    bottom:0;
    left:0;
    text-transform: uppercase;
    border-radius:5px;
    width:80px;
}
.resolution-switcher ul li{
    color:#333;
}
.resolution-switcher ul li.selected{
    color:#000;
    font-weight: bold;
}
.resolution-switcher ul li:hover{
    background:rgba(0,0,0,.3);
}
.draw-panel{
    position:absolute;
    background: #fff;
    color:#000;
    max-width:138px;
    padding:5px;
    outline:5px solid rgba(255,255,255,.3);
    bottom: 80px;
    margin-left:5px;
}
.btn-color{
    border:2px solid #FFFFFF;
}
.draw-panel.panel-color{left:5px;}
.draw-panel.panel-size{left:25px;}
.draw-panel.panel-shapemode{left:90px;}
.draw-panel ul{
    list-style-type: none;
    margin:0;
    padding:0;
    display:flex;
    flex-direction: row;
    flex-wrap: wrap;
}
.draw-panel ul li a{
    background:black;
    width:32px;
    height:32px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.draw-panel ul li a:hover{
    opacity: 0.4;
}
.draw-panel ul li a img{
    margin:7px 0 0 0;
}
.draw-panel.panel-color .color{
    display: block;
    width:32px;
    height:32px;
    outline:1px solid #000;
}
.draw-panel.panel-size .size{
    background: #fff;
    display:block;
    border-radius:50%;
}
button.btn-transparent>*{
    filter:drop-shadow(0px 4px 5px rgba(0,0,0,.8));
}
/* 
button.btn-transparent:after{
    display:block;
    content:'';
    width:26px;
    height:26px;
    border:2px solid rgba(255,255,255,.1);
    border-radius:50%;
    position:absolute;
    top:0;
    left:0;
    box-shadow: 10px 10px 10px rgba(0,0,0,.1) inset,
                20px 0px 10px rgba(255,255,255,.1) inset;
} */
button .size{
    background: #fff;
    display:block;
    text-align:center;
    border-radius:50%;
    left: auto;
    right: auto;
    margin: auto;
}
</style>
<script>
import help from "../../_components/help"
export default {
    props: {
        autozoom: {type: Object, default: null},
        enableTagClip: {type: Boolean, default: false},
        enableAutozoom: {type: Boolean, default: false},
        currentTime: { type: Number, default: 0 },
        duration: { type: Number, default: 0 },
        playing: { type: Boolean, default: false },
        enableDraw: { type: Boolean, default: false },
        enablePZR: { type: Boolean, default: false },
        enablePreview: { type: Boolean, default: false },
        actualZoom: {type: Number, default: 1},

        mode: { type: String, default: undefined },
        enableEdit: {type: Boolean, default: false  },
        showTogglePreview: { type: Boolean, default: false },
        showTogglePZR: { type: Boolean, default: false },
        showToggleDraw: { type: Boolean, default: false },
        selectedResolution: { type: String },
        availableResolutions: { type: Array, default: function(){ return []; } }
    },
    components:{
        help
    },
    data(){
        return {
            colors:         ['maroon','red','orange','yellow','olive', 'green','lime',
                             'purple','fuchsia','teal','aqua','blue',
                             'black','silver','gray','white'],
            sizes:          [4,8,12,16],
            modes:          ['draw','rectangle','circle'],


            drawColorPanel: false,
            drawSizePanel:  false,
            drawShapePanel: false,

            drawColor:      "red",
            drawBrushSize:  12,
            drawShapeMode:  "draw",

            showResolution: false,
            showTagList: false,

            autozoom_by_player: false
        }
    },
    methods: {
        requestAutozoom: function(){
            this.$emit("requestAutozoom")
        },
        play: function(autozoom){
            if(this.mode == 'marker' && !this.enablePreview){
                this.$emit("togglePreview");
            }
            if(autozoom && !this.enablePreview){
                this.autozoom_by_player = true;
                this.$emit("togglePreview")
            }else if(this.autozoom_by_player && this.enablePreview){
                this.autozoom_by_player = false;
                this.$emit("togglePreview");
                if(this.actualZoom > 1){
                    this.$emit("zoomTo", 1)
                }
            }
            this.$emit('play')
        },
        recordMarkers: function(){
            if(this.enablePreview)
                this.$emit("togglePreview")
            this.$emit("play");
        },
        stopRecordMarkers: function(){
            this.$emit("stop")
        }
    },
    watch: {
        mode: function(){
            this.drawShapePanel = false;
            this.drawColorPanel = false;
            this.drawSizePanel = false;
        }
    }
}
</script>